module.exports = __webpack_public_path__ + "img/overseas-business-wechat-official-accounts_2.1d0ebbfe.png";